// Redux
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  client: {},
  clinics: [],
  allClients: [],
};

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClient: (state, action) => {
      state.client = action.payload.client;
      state.clinics = action.payload.clinics || [];
    },
    setAllClients: (state, action) => {
      state.allClients = action.payload;
    },
  },
});

export const selectClient = (state) => state.client.client;
export const selectClinics = (state) => state.client.clinics;
export const selectAllClients = (state) => state.client.allClients;

export const { setClient, setAllClients } = clientSlice.actions;

export default clientSlice.reducer;
